import type { FC } from 'react';
import { Icons } from '../../icons';

interface LockIconProps {
  isLocked: boolean;
  onClick?: (() => void) | undefined;
  title?: string | undefined;
}

export const LockIcon: FC<LockIconProps> = ({ isLocked, onClick, title }) => (
  <span
    className={`lock-icon ${isLocked ? 'locked' : 'unlocked'}`}
    onClick={onClick}
    title={title}
    role={onClick ? 'button' : undefined}
    tabIndex={onClick ? 0 : undefined}
    style={{ cursor: onClick ? 'pointer' : 'default' }}
  >
    {isLocked ? <Icons.Lock /> : <Icons.Unlock />}
  </span>
);
